import type {
  ActivityLogData,
  ActivityLogReq,
  ActivityLogsRequest,
  Applications,
  EventTypes
} from '@/models/interface/social';
import { ApiFactory } from '@/utils/api';
import type { AxiosResponse } from 'axios';

const baseUrl: string = import.meta.env.VITE_SOCIALLOG_BASE_URL;

export class SocialLogService extends ApiFactory {
  constructor() {
    super(baseUrl);
  }

  /** 下面四個事件要排除不顯示
    {
      "id": "67513e64862aa08f74ca53f1",
      "name": "CompeletQuestionnaire",
      "description": "Userr complete the sales questionnair",
      "createAt": 1733377636,
      "updateAt": "0001-01-01T00:00:00Z"
    },
    {
      "id": "67513e47862aa08f74ca53ef",
      "name": "FillingQuestionnaire",
      "description": "Userr is answering the sales questionnair, but not finish",
      "createAt": 1733377607,
      "updateAt": "0001-01-01T00:00:00Z"
    },
    {
      "id": "67513e0d862aa08f74ca53eb",
      "name": "SkipQuestionnaire",
      "description": "Userr Skip the sales questionnair",
      "createAt": 1733377549,
      "updateAt": "0001-01-01T00:00:00Z"
    },
    {
      "id": "67513ded862aa08f74ca53e8",
      "name": "ViewQuestionnaire",
      "description": "After completing the level selection form, the user will encounter a sales questionnaire if the registration date is within the past 10 days.",
      "createAt": 1733377517,
      "updateAt": "0001-01-01T00:00:00Z"
    },
    {
      "id": "67513d79862aa08f74ca53e1",
      "name": "SelectLevel",
      "description": "If the user is new, they need to complete the level selection form.",
      "createAt": 1733377401,
      "updateAt": "0001-01-01T00:00:00Z"
    } 
   * */
  getActivityLogs(param: ActivityLogReq): Promise<AxiosResponse<ActivityLogData>> {
    return super.post(
      'ActivityLogs/v2/filter/multiple',
      {
        paging: param,
        includedApplicationIds: ['66e2b8e98254f24941876231'], // 66e2b8e98254f24941876231 => funday application ID
        includedEventTypeIds: [
          '66f4d3fb585787fadefd796c',
          '66e2c61c8254f24941876238',
          '66e2b90d8254f24941876233',
          '66e2b9008254f24941876232'
        ]
      },
      {
        headers: {
          disableGlobalLoading: true
        }
      }
    );
  }
  /**
   *  新增log
   * @param params ActivityLogsRequest
   */
  setActivityLogs(params: ActivityLogsRequest): Promise<AxiosResponse<any>> {
    return super.post('ActivityLogs', params, {
      headers: { disableGlobalLoading: true, 'X-Silent-Error': 'true' }
    });
  }
  /**
   *  取得 Applications 對照表
   * (如果沒有要去swagger塞)
   */
  getApplications(): Promise<AxiosResponse<Applications[]>> {
    return super.get('Applications');
  }
  /**
   *  取得 EventTypes 對照表
   * (如果沒有要去swagger塞)
   */
  getEventTypes(): Promise<AxiosResponse<EventTypes[]>> {
    return super.get('EventTypes');
  }
}
